import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';

const EmptyCart = ({ labels , onClick  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart",
        "data-t": "empty-cart"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "large"
    }, labels.cartTitle), /*#__PURE__*/ React.createElement("div", {
        className: "cart__empty-message"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "small"
    }, labels.emptyCartTitle), /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, labels.emptyCartMessage), /*#__PURE__*/ React.createElement(Button, {
        className: "cart__button cart__empty-message-button",
        color: "primary",
        caption: labels.buttonCaption,
        onClick: onClick,
        "aria-label": labels.buttonCaption
    })))
;

export { EmptyCart };
//# sourceMappingURL=EmptyCart.js.map
